<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        权限管理
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="姓名" label-for="name">
          <b-form-input id="name" type="text" v-model="data.name" :disabled="true" />
        </b-form-group>
        <b-form-group label="Email" label-for="email">
          <b-form-input id="email" type="text" v-model="data.email" :disabled="true" />
        </b-form-group>
        <b-form-group label="部门" label-for="remark">
          <b-form-input id="remark" type="text" v-model="data.remark" required />
        </b-form-group>
        <b-form-group label="手机号" label-for="mobile">
          <b-form-input id="mobile" type="text" v-model="data.mobile" required />
        </b-form-group>
        <b-form-group label="类型" label-for="admin_type">
          <b-form-select
              id="admin_type"  v-model="data.admin_type"
              :options="admin_types">
          </b-form-select>
        </b-form-group>
        <b-form-group label="点赞中心权限" label-for="vote_auth">
          <b-form-radio-group
            id="vote_auth"
            v-model="data.vote"
            :options="vote_options"
            name="radio-options" />
        </b-form-group>
        <b-form-group label="点赞中心权限（海外版）" label-for="edition_auth">
          <b-form-radio-group
            id="edition_auth"
            v-model="data.edition"
            :options="edition_options"
            name="edition-radio-options" />
        </b-form-group>
        <b-form-group label="权限" label-for="authority">
          <b-table small responsive="sm" :items="data.authority" :fields="service_fields" >
            <template #cell(service_code)="row">
              <span v-if="services[row.item.service_code]">{{ services[row.item.service_code] }}</span>
              <span v-else>
                <b-form-select
                  id="service"  v-model="row.item.service_code"
                  :options="filteredServices" size="sm" >
                </b-form-select>
              </span>
            </template>
            <template #cell(show_details)="row">
              <b-button size="sm" class="mr-2" @click.stop="row.toggleDetails" variant="outline-primary">
                <span class="fa fa-gear" />
              </b-button>
              <b-button size="sm" class="mr-2" variant="outline-danger"
                        @click="data.authority.splice(row.index, 1)">
                <span class="fa fa-minus" />
              </b-button>
              <b-button v-if="displayAddService(row, data.authority)"
                        @click="addService(data.authority)" size="sm" class="mr-2" variant="outline-success">
                <span class="fa fa-plus" />
              </b-button>
            </template>
            <template #cell(row-details)="row">
              <b-card >
                <b-row class="mb-2" v-for="(p_auth, index) in row.item.authority" :key="p_auth.product_code">
                  <b-col sm="2" >
                    <b v-if="p_auth.product_code">{{ products[p_auth.product_code] }}</b>
                    <b v-else>
                      <b-form-select
                        id="product"  v-model="p_auth.product_code"
                        :options="filteredProducts(row.item.authority)" size="sm" >
                      </b-form-select>
                    </b>
                  </b-col>
                  <b-col>
                    <b-form-select v-model="p_auth.role_id" :options="roles" size="sm"
                                   :von-change="changePerm([p_auth.role_id, p_auth])">
                    </b-form-select>
                    <b-form-checkbox-group name="authority" v-model="p_auth.mask" :disabled="true"
                                           :options="getAuthOptions(p_auth.mask)">
                    </b-form-checkbox-group>
                  </b-col>
                  <b-col sm="2">
                    <b-button size="sm" class="mr-2" variant="outline-danger"
                        @click="removeProduct(row, index, data.authority)">
                      <span class="fa fa-minus" />
                    </b-button>
                    <b-button v-if="displayAddProduct(p_auth, index, row.item.authority)" size="sm"
                        @click="addProduct(row.item.authority)" class="mr-2" variant="outline-success">
                      <span class="fa fa-plus" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </template>
          </b-table>
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check" /> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-secondary"><i class="fa fa-remove" /> 返回</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import utils from '@/utils/utils'
import consts from '@/utils/consts'

var defaultAuth = {
  'service_code': null,
  '_showDetails': true,
  'authority': [
    {'product_code': null, 'mask': []}
  ]
}

export default {
  name: 'admin-update',
  mixins: [Error],
  data () {
    return {
      data: {},
      admin_types: consts.ADMIN_TYPES,
      vote_options: consts.VOTE_RADIO_JUDGE_OPTIONS,
      edition_options: consts.VOTE_RADIO_JUDGE_OPTIONS,
      products: {},
      services: {},
      roles: [],
      service_fields: consts.SERVICE_PERM_FIELDS
    }
  },
  computed: {
    filteredServices: function () {
      var services = {}
      Object.keys(this.services).forEach((id) => {
        if (!utils.inArray(id, this.data.authority, 'service_code')) {
          services[id] = this.services[id]
        }
      })
      return services
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.$ajax.all([
        this.$ajax.get(api.getProductList()), this.$ajax.get(api.getServiceList()),
        this.$ajax.get(api.getRoleList()),
        this.$ajax.get(api.getAdminDetail(this.$route.params.id))
      ]).then(([productData, serviceData, roleData, adminData]) => {
        productData.products.forEach((product) => {
          this.products[product.code] = product.name
        })
        serviceData.services.forEach((service) => {
          this.services[service.code] = service.name
        })
        roleData.roles.forEach((role) => {
          this.roles.push({
            value: role['_id'],
            text: role['name'],
            mask: utils.maskToArray(role['mask'])
          })
        })
        adminData.admin_info.authority.forEach((sAuth) => {
          sAuth.authority.forEach((auth, i) => {
            sAuth.authority[i].mask = utils.maskToArray(auth.mask)
          })
        })
        if (!adminData.admin_info.authority.length) {
          adminData.admin_info.authority = [utils.copyObject(defaultAuth)]
        }
        this.data = adminData.admin_info
      }, (res) => {
        this.handleError(res[0])
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      let parsedData = utils.copyObject(this.data)
      parsedData.authority.forEach((sAuth) => {
        sAuth.authority.forEach((auth, i) => {
          sAuth.authority[i].mask = utils.arrayToMask(auth.mask)
        })
      })
      if (!(/^1[3456789]\d{9}$/.test(this.data.mobile))) {
        this.$message.error('手机号码有误，请重填')
      } else {
        api.updateData(this, api.getAdminDetail(this.$route.params.id), parsedData)
      }
    },
    onReset (evt) {
      this.$router.go(-1)
    },
    getAuthOptions (authMask) {
      return utils.getAuthOptions(authMask)
    },
    displayAddService (row, items) {
      if (
        row.index === items.length - 1 && row.item.service_code &&
        Object.keys(this.filteredServices).length > 0
      ) {
        return true
      }
      return false
    },
    addService (authList) {
      authList.push(utils.copyObject(defaultAuth))
    },
    displayAddProduct (pAuth, index, items) {
      if (
        index === items.length - 1 && pAuth.product_code &&
        Object.keys(this.filteredProducts(items)).length > 0
      ) {
        return true
      }
      return false
    },
    addProduct (authList) {
      authList.push({'product_code': null, 'mask': []})
    },
    removeProduct (pAuth, index, sAuth) {
      pAuth.item.authority.splice(index, 1)
      if (!pAuth.item.authority.length) {
        sAuth.splice(pAuth.index, 1)
      }
    },
    filteredProducts (pAuth) {
      let products = {}
      Object.keys(this.products).forEach((id) => {
        if (!utils.inArray(id, pAuth, 'product_code')) {
          products[id] = this.products[id]
        }
      })
      return products
    },
    changePerm (params) {
      let roleId = params[0]
      let pAuth = params[1]
      let roleMask = utils.findInArray(this.roles, roleId, 'mask', 'value')
      if (roleMask) {
        pAuth.mask = roleMask
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AdminUpdate.vue?4dd56950